import styled from "styled-components";

const StyledChoosingTariffsDiscount = styled.div`
    width: 100%;
    margin: auto;
    padding: 3px 7px;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    border-radius: 4px;
    box-shadow: 4px 4px 12px 0px rgba(0, 0, 0, 0.12);
    background-color: #fff;

    label {
        font-size: 14px;

    }

    input[type = radio] {
        width: 16px;
        margin: 0 3px;
        accent-color: black;
        &:focus {
          box-shadow: none;
          outline: none;
        }
    }

    hr {
        height: 20px;
        margin-left: 10px;
    }
`;

export {StyledChoosingTariffsDiscount};